import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
export function PricingSection() {
  const benefits = ['Menos pensamiento', 'Más ejecución', 'Más pacientes', 'Más ingresos'];
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('kine_countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const duration = Math.floor(Math.random() * (1800 - 600 + 1)) + 600;
    sessionStorage.setItem('kine_countdown_end', String(Date.now() + duration * 1000));
    return duration;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="compra" className="w-full px-4 py-20 bg-gradient-to-b from-[#1e293b] to-[#0f172a]" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          <h2 className="text-3xl md:text-5xl font-black mb-8 text-center" data-id="element-68">
            Empezá a trabajar con un sistema real
          </h2>

          <div className="grid md:grid-cols-4 gap-4 mb-12" data-id="element-69">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} className="bg-[#1e293b] border border-yellow-400/30 p-4 rounded-lg text-center" data-id="element-70">
                <CheckCircle2Icon className="w-6 h-6 text-yellow-400 mx-auto mb-2" data-id="element-71" />
                <p className="font-semibold" data-id="element-72">{benefit}</p>
              </motion.div>)}
          </div>

          <div className="bg-gradient-to-br from-yellow-400/20 to-yellow-400/5 border-2 border-yellow-400 p-8 md:p-12 rounded-2xl shadow-2xl shadow-yellow-400/20" data-id="element-73">
            <div className="text-center mb-8" data-id="element-74">
              <div className="inline-flex items-center gap-2 bg-[#ef4444] text-white px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-75">
                <ClockIcon className="w-4 h-4" data-id="element-76" />
                OFERTA POR TIEMPO LIMITADO
              </div>

              {/* Countdown Timer */}
              <div className="mb-8" data-id="element-77">
                <p className="text-gray-300 text-lg mb-4" data-id="element-78">
                  Esta oferta expira en:
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-79">
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-4 py-3 min-w-[70px]" data-id="element-80">
                    <p className="text-3xl md:text-4xl font-black text-[#ef4444]" data-id="element-81">
                      {String(hours).padStart(2, '0')}
                    </p>
                    <p className="text-xs text-gray-400 uppercase" data-id="element-82">Horas</p>
                  </div>
                  <span className="text-3xl font-black text-[#ef4444]" data-id="element-83">:</span>
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-4 py-3 min-w-[70px]" data-id="element-84">
                    <p className="text-3xl md:text-4xl font-black text-[#ef4444]" data-id="element-85">
                      {String(minutes).padStart(2, '0')}
                    </p>
                    <p className="text-xs text-gray-400 uppercase" data-id="element-86">Min</p>
                  </div>
                  <span className="text-3xl font-black text-[#ef4444]" data-id="element-87">:</span>
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-4 py-3 min-w-[70px]" data-id="element-88">
                    <p className="text-3xl md:text-4xl font-black text-[#ef4444]" data-id="element-89">
                      {String(seconds).padStart(2, '0')}
                    </p>
                    <p className="text-xs text-gray-400 uppercase" data-id="element-90">Seg</p>
                  </div>
                </div>
              </div>

              <div className="mb-6" data-id="element-91">
                <p className="text-gray-400 text-xl mb-2" data-id="element-92">Precio regular:</p>
                <p className="text-3xl text-gray-500 line-through font-bold" data-id="element-93">
                  $49.990
                </p>
              </div>

              <div className="mb-4" data-id="element-94">
                <p className="text-gray-300 text-xl mb-2" data-id="element-95">
                  Precio de lanzamiento:
                </p>
                <p className="text-6xl md:text-7xl font-black text-yellow-400 mb-2" data-id="element-96">
                  $19.990
                </p>
                <p className="text-gray-400" data-id="element-97">Pago único • Acceso inmediato</p>
              </div>

              <p className="text-sm text-yellow-400 font-semibold mb-6" data-id="element-98">
                ✅ Incluye todos los bonos GRATIS por hoy
              </p>

              <motion.a href="https://checkout.ebookpoint.shop/cart/59394129592401:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center gap-3 bg-yellow-400/90 text-black px-12 py-6 rounded-xl font-black text-2xl shadow-lg shadow-yellow-400/40 hover:shadow-yellow-400/60 transition-shadow" data-id="element-99">
                <ShoppingCartIcon className="w-8 h-8" data-id="element-100" />
                COMPRAR AHORA
              </motion.a>

              <p className="text-sm text-gray-400 mt-6" data-id="element-101">
                🔒 Pago seguro • Acceso instantáneo • Garantía de satisfacción
              </p>
            </div>

            <div className="border-t border-yellow-400/30 pt-6" data-id="element-102">
              <p className="text-center text-gray-300 text-lg" data-id="element-103">
                Al hacer clic en "COMPRAR AHORA" serás redirigido a la página de
                pago seguro
              </p>
            </div>
          </div>

          <div className="mt-8 bg-[#f97316]/20 border border-[#f97316] p-6 rounded-lg text-center" data-id="element-104">
            <p className="text-xl font-bold text-[#f97316]" data-id="element-105">
              ⚡ Esta oferta puede terminar en cualquier momento
            </p>
            <p className="text-gray-300 mt-2" data-id="element-106">
              No pierdas la oportunidad de transformar tu práctica clínica hoy
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}